import MaterialTableCell from "@mui/material/TableCell";
import React, { FC } from "react";
import { styled } from "@mui/material/styles";
import { COLOR_DOWNRIVER } from "../../constants/styles";

const StyledTableCell = styled(MaterialTableCell)`
  height: 44px;

  &.MuiTableCell-head {
    padding: 12px;
    text-transform: uppercase;
  }
  &.MuiTableCell-body {
    padding: 8px 12px;
    color: ${COLOR_DOWNRIVER};
  }
`;

export const TableCell: FC<any> = React.forwardRef((props, ref) => <StyledTableCell {...(props as any)} ref={ref} />);
